import { api } from './api';
import type { Profile, UpdateProfileDTO, ChangePasswordDTO, UpdateAvatarDTO } from '@/types/profile';
import type { ApiResponse } from '@/types/api';

class ProfileService {
  // Get profile URL based on user type
  private getProfileUrl(): string {
    // Unified profile endpoint for all user types
    return '/profile';
  }

  // Get current user profile (api interceptor returns unwrapped data)
  async getProfile(): Promise<Profile> {
    return api.get<Profile>(this.getProfileUrl());
  }

  // Update profile
  async updateProfile(data: UpdateProfileDTO): Promise<ApiResponse<Profile>> {
    return api.put(this.getProfileUrl(), data);
  }

  // Change password
  async changePassword(data: ChangePasswordDTO): Promise<ApiResponse<void>> {
    const baseUrl = this.getProfileUrl();
    return api.post(`${baseUrl}/password`, data);
  }

  // Update avatar
  async updateAvatar(data: UpdateAvatarDTO): Promise<ApiResponse<Profile>> {
    const baseUrl = this.getProfileUrl();
    return api.patch(`${baseUrl}/avatar`, data);
  }

  // Upload avatar
  async uploadAvatar(file: File): Promise<ApiResponse<{ url: string }>> {
    const formData = new FormData();
    formData.append('avatar', file);
    return api.post('/profile/upload-avatar', formData);
  }
}

export const profileService = new ProfileService();
